import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { catchError, Observable } from 'rxjs';
import { DisplayType, PRODUCT_URL } from '../shared/src';
import { ErrorHandlerService } from './error-handler.service';
@Injectable({
    providedIn: 'root',
})
export class CoreRangeService {
    private readonly URL_PATH = `${PRODUCT_URL}/coreRanges`;

    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }

    /**
 * Api for getAll DisplayType Info
 */
    public accountGetAll(
        pageIndex?: number,
        pageSize?: number,
        searchFilter?: string,
        status?: number,
        countryId?: number
    ): Observable<any> {
        let queryParams = new HttpParams();
        // Only send search filter if it has at least 3 characters or is empty
        if (searchFilter && searchFilter.trim() && searchFilter.trim().length >= 3) {
            queryParams = queryParams.set('searchFilter', searchFilter.trim());
        }

        if (countryId) {
            queryParams = queryParams.set('countryId', countryId);
        }

        return this.http
            .post<any>(
                `${this.URL_PATH}/getByCountry`,
                {},
                { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Sends a POST request to the server to add a new display type's information.
     * @param data - The display type data to be added
     * @returns
     */
    public addAccountDetails(data: {
        id: number;
        name: string;
        accountIds: number[];
    }): Observable<any> {
        console.log(data);

        return this.http
            .post<any>(`${this.URL_PATH}/save`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Toggel status.
     * @param id - The unique identifier of the status
     */

    updateToggleAccountStatus(id: number): Observable<any> {
        return this.http
            .put<any>(`${this.URL_PATH}/changeStatus/${id}`, null)
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Deletes a channel from the server.
     * @param id - The unique identifier of the channel to be deleted.
     * @returns An Observable that emits a confirmation message upon successful deletion.
     */
    public deleteAccount(id: number): Observable<string> {
        return this.http
            .delete<string>(`${this.URL_PATH}/delete/${id}`)
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Deletes a display type from the server.
     * @param id - The unique identifier of the display type to be deleted.
     * @returns An Observable that emits a confirmation message upon successful deletion.
     */
    public deleteDisplayType(id: number): Observable<string> {
        return this.http
            .delete<string>(`${this.URL_PATH}/delete/${id}`)
            .pipe(catchError(this.errorHandler.handleError));
    }

    // to get active channel status
    public getAllActiveAccount(searchFilter?: string): Observable<any> {
        let queryParams = new HttpParams();
        // Only send search filter if it has at least 3 characters or is empty
        if (searchFilter && searchFilter.trim() && searchFilter.trim().length >= 3) {
            queryParams = queryParams.set('searchFilter', searchFilter.trim());
        }
        return this.http
            .get<any>(`${this.URL_PATH}/getAll`, { params: queryParams })
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * export accounts
     * @returns blob
     */
    public exportAccounts(): Observable<Blob> {
        const columns: string[] = ['Key DisplayType', 'Channel', 'Country']; //export needed columns
        // const columns:string[] = []; //export all columns

        return this.http
            .post<Blob>(
                `${this.URL_PATH}/downloadExcelReport`,
                { columns },
                {
                    responseType: 'blob' as 'json',
                }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }

    // to get the dropdown for regions and country in text in excel
    public downloadExcelTemplate() {
        return this.http
            .get(`${this.URL_PATH}/downloadExcelTemplate`, {
                responseType: 'blob',
            })
            .pipe(catchError(this.errorHandler.handleError));
    }
    /**
     * Updates DisplayType information on the server.
     * @param data - The DisplayType data to be updated.
     * @returns An Observable that emits the DisplayType.
     */
    public update(data: { id: number; name: string; accountIds: number[] }): Observable<any> {
        return this.http
            .post<any>(`${this.URL_PATH}/update`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public importAccountData(data: any): Observable<DisplayType[]> {
        return this.http
            .post<DisplayType[]>(`${this.URL_PATH}/importAccountData`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getAccountByChannelId(countryId: number, channelId: number, searchFilter?: string): Observable<any> {
        let queryParams = new HttpParams();
        // Only send search filter if it has at least 3 characters or is empty
        if (searchFilter && searchFilter.trim() && searchFilter.trim().length >= 3) {
            queryParams = queryParams.set('searchFilter', searchFilter.trim());
        }
        if (countryId) {
            queryParams = queryParams.set('countryId', countryId);
        }
        if (channelId) {
            queryParams = queryParams.set('channelId', channelId);
        }
        return this.http.get<any>(`${this.URL_PATH}/getAccountByChannelId`, { params: queryParams })
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getAccountIdForPic(): Observable<any> {
        return this.http.get<any>(`${this.URL_PATH}/getAccountidforPic`)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public updateToggleInvoiceRequired(id: number): Observable<any> {
        return this.http
            .put<any>(`${this.URL_PATH}/changeInvoiceStatus/${id}`, null)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public updateToggleEnterPrice(id: number): Observable<any> {
        return this.http
            .put<any>(`${this.URL_PATH}/changeEnterPriceStatus/${id}`, null)
            .pipe(catchError(this.errorHandler.handleError));
    }

}
